export default __webpack_public_path__ + "static/813-8d46ea6546e9c8042261318de4e214d1.gif";